export default __webpack_public_path__ + "static/media/icon_mail_32.91db2bd1.svg";